



























































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class IconViewer extends Vue {
    @Prop({ required: false }) readonly color?: string;
    @Prop({ required: false }) readonly isHidden?: boolean;
}
